import { httpClient } from '../httpClient';
export class SubContractHikari01TelRepository {
    constructor() {
        this.basePath = 'sub-contract-hikari01-tel';
    }
    async fetch(params) {
        const { data } = await httpClient.get(`${this.basePath}/${params.subContractId}/fetch`);
        return data;
    }
    async fetchValid() {
        const { data } = await httpClient.get(`${this.basePath}/valid/fetch`);
        return data;
    }
    async fetchList(params) {
        const { data } = await httpClient.get(
        // JWT内accountIdを使用して検索
        `${this.basePath}/list/${params.accountId}/fetch`);
        return data;
    }
    async terminateIenodenwa() {
        const { data } = await httpClient.post(`${this.basePath}/ienodenwa/terminate`);
        return data;
    }
    async terminateGateCallF() {
        const { data } = await httpClient.post(`${this.basePath}/gate-call-f/terminate`);
        return data;
    }
    async terminateGateCallM() {
        const { data } = await httpClient.post(`${this.basePath}/gate-call-m/terminate`);
        return data;
    }
    async applyIenodenwa(params) {
        const { data } = await httpClient.post(
        // JWT内accountIdを使用して検索
        `${this.basePath}/ienodenwa/apply`, JSON.stringify(({
            newOrNp: params.newOrNp,
            npTelNumber: params.npTelNumber,
            npPortoutCompany: params.npPortoutCompany,
            opOptionPackFlg: params.opOptionPackFlg,
            opSenderNumberDisplayFlg: params.opSenderNumberDisplayFlg,
            opWarikomiFlg: params.opWarikomiFlg,
            opWarikomiDisplayFlg: params.opWarikomiDisplayFlg
        } = params)));
        return data;
    }
    async changeIenodenwaOption(params) {
        const { data } = await httpClient.post(
        // JWT内accountIdを使用して検索
        `${this.basePath}/ienodenwa/option/change`, JSON.stringify(({
            opOptionPack: params.opOptionPack,
            opSenderNumberDisplay: params.opSenderNumberDisplay,
            opWarikomi: params.opWarikomi,
            opWarikomiDisplay: params.opWarikomiDisplay
        } = params)));
        return data;
    }
}
